// material-ui
import { useTheme } from '@mui/material/styles';
import { CircularProgress, Divider, Grid, Typography } from '@mui/material';

// project imports
import { gridSpacing } from 'store/constant';

// assets
import MainCard from 'ui/ui-component/cards/MainCard';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import PaynowBillerCard from 'ui/ui-component/cards/PaynowBillerCard';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import zimServices from '../zim-services';
import ServicesCard from 'ui/ui-component/cards/ServicesCard';

// ==============================|| Biller Department Home Page ||============================== //

const BillerDepartmentData = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const billerDepartment = useSelector((state) => state.billerDepartment.departmentBillers);
    let params = useParams();
    const department = params.department;
    let zimPaynowServicesResult = <></>;

    if (billerDepartment?.billers) {
        zimPaynowServicesResult = billerDepartment?.billers.map((billerData, index) => {
            return (
                <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
                    <PaynowBillerCard {...billerData} />
                </Grid>
            );
        });
    }

    
    let zimServicesResult = <></>;
    const filteredProducts = zimServices.filter(service => service.department === billerDepartment?.department);

    if (filteredProducts) {
        zimServicesResult = filteredProducts.map((service, index) => (
            <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={2}>
                <ServicesCard {...service} />
            </Grid>
        ));
    }


    return (
        <>
            {' '}
            <Helmet>
                <title>{`${billerDepartment?.department}`} - Simplex Solutions</title>
                <link rel="canonical" href={`/services/zimbabwe/${department}`} />
                <meta name="description" content={billerDepartment?.department} />
            </Helmet>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <MainCard
                        title={
                            <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                                <Grid item>
                                    <Typography variant="h3">{billerDepartment?.department}</Typography>
                                </Grid>
                            </Grid>
                        }
                    >
                        <Grid container spacing={gridSpacing}>
                            <Grid className="block" item xs zeroMinWidth sx={{ display: 'flex' }}>
                                <Grid container alignItems="center" spacing={gridSpacing}>
                                    <Grid item xs={12}>
                                        <Grid container direction="row" spacing={gridSpacing}>
                                            {loading && (
                                                <Grid item xs={12}>
                                                    <Grid container spacing={2} justifyContent="center" sx={{ mt: 3 }}>
                                                        <Grid item>
                                                            <CircularProgress />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {zimPaynowServicesResult}
                                            {zimServicesResult}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MainCard>
                </Grid>
            </Grid>
        </>
    );
};

export default BillerDepartmentData;
